import morphism, { StrictSchema } from 'morphism'

import ClientPassengerInterface from '../../interfaces/client/Passenger'
import ServerPassengerInterface from '../../interfaces/server/Passenger'

import serverPassengerSchema from '../../schemas/server/passenger'

export default (passenger: ClientPassengerInterface) =>
  morphism<StrictSchema<ServerPassengerInterface, ClientPassengerInterface>>(
    serverPassengerSchema,
    passenger
  )
